import { PublicBoxProps, FlexProps } from '@withjoy/joykit';
import { ChevronDown } from '@withjoy/joykit/icons';
import React, { useCallback, useRef } from 'react';
import { AccordionContainer, VisibleContent, CollapsedContent, ToggleButton, styles, VisibleContentWrapper } from './styles';
import { withWindow } from '@shared/utils/withWindow';

export const Accordion = (props: PublicBoxProps) => {
  return (
    <AccordionContainer
      __css={styles.accordionContainer}
      {...props}
    />
  );
};

interface AccordionVisibleContentProps {
  handleOnToggle: () => void;
  isOpen: boolean;
}

const AccordionVisibleContent: React.FC<AccordionVisibleContentProps & FlexProps> = ({ children, handleOnToggle, isOpen, ...props }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleOnClick = useCallback(() => {
    withWindow(window => {
      window.setTimeout(() => {
        wrapperRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    });
    handleOnToggle();
  }, [handleOnToggle]);

  return (
    <VisibleContentWrapper
      __css={styles.visibleContentWrapper}
      ref={wrapperRef}
    >
      <VisibleContent
        __css={styles.visibleContent}
        onClick={handleOnClick}
        {...props}
      >
        {children}
        <ToggleButton __css={styles.toggleButton(isOpen)}>
          <ChevronDown />
        </ToggleButton>
      </VisibleContent>
    </VisibleContentWrapper>
  );
};

const AccordionCollapsedContent = ({ isOpen, ...props }: PublicBoxProps & Pick<AccordionVisibleContentProps, 'isOpen'>) => (
  <CollapsedContent
    __css={styles.collapsedContent(isOpen)}
    {...props}
  />
);

Accordion.VisibleContent = AccordionVisibleContent;
Accordion.CollapsedContent = AccordionCollapsedContent;
